export default __webpack_public_path__ + "static/media/d8.2fa733b8.jpeg";